module.exports = __webpack_public_path__ + "static/media/arrow.18ab8e42.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/arrow.svg
// module id = 127
// module chunks = 0